import { ButtonPrimary, Colors, Icon } from '@amelio/ui-library';
import { useTranslation } from 'react-i18next';

import { IconCircle } from '../components/surfaces';
import { useOpenObjectiveCycles } from '../hooks/useOpenObjectiveCycles';

import { Permission } from '@/constants/Permission';
import { useUserPermissions } from '@/hooks/api/useUserPermissions';

/**
 * Shown instead of the list when the company has no objective cycle at all: without one there is
 * nothing to measure "without an objective" against, so saying everybody has one would be false.
 * The way out is offered only to those who may create a cycle.
 */
export default function NoObjectiveCycleState() {
    const { t } = useTranslation();
    const { can } = useUserPermissions();
    const openObjectiveCycles = useOpenObjectiveCycles();

    return (
        <div
            className={'flex flex-col items-center gap-4 py-12 text-center'}
            data-testid={'employees-without-objectives-no-cycle'}
        >
            <IconCircle className={'bg-obj-tint h-[64px] w-[64px]'}>
                <Icon
                    name={'time-calendar'}
                    size={32}
                    color={Colors.STEP_RAIL_TURQUOISE}
                    strokeWidth={1.6}
                />
            </IconCircle>

            <p className={'text-navy font-medium'}>
                {t('employeesWithoutObjectives.noCycle.message')}
            </p>

            {can(Permission.ManageAllEmployeesObjectives) && (
                <ButtonPrimary
                    onClick={openObjectiveCycles}
                    size={'sm'}
                    fitContent
                    dataTestId={'employees-without-objectives-create-cycle'}
                >
                    {t('employeesWithoutObjectives.noCycle.action')}
                </ButtonPrimary>
            )}
        </div>
    );
}
